import { render, staticRenderFns } from "./pay-dialog.vue?vue&type=template&id=115c24d9&scoped=true&"
import script from "./pay-dialog.vue?vue&type=script&lang=js&"
export * from "./pay-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115c24d9",
  null
  
)

export default component.exports